// The fixed parts of a tag chip around its label, shared by the chips' styles and the widths a row
// fits them by.

export const TAG_CHIP_BORDER_WIDTH = 1;

export const LISTED_TAG_CHIP = {
    paddingInline: 12,
    marginInline: 4
};
